import { render, staticRenderFns } from "./ContentVideoPlayer.vue?vue&type=template&id=88664148&"
import script from "./ContentVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./ContentVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./ContentVideoPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports